module.exports = __webpack_public_path__ + "img/check-red.033c8ad1.svg";